const { algoliasearch, instantsearch } = window;
const { autocomplete } = window['@algolia/autocomplete-js'];
const { createLocalStorageRecentSearchesPlugin } =
  window['@algolia/autocomplete-plugin-recent-searches'];
const { createQuerySuggestionsPlugin } =
  window['@algolia/autocomplete-plugin-query-suggestions'];

import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";

const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
  server: {
    apiKey: "fR455meh9IqezHOyV2tLmhX26PbyPh3XE3UysrsUE6oPtPzr", // Be sure to use the search-only-api-key
    nodes: [
      { 
//        host: "ps1.typetype.org",
//        port: 10100,
//        protocol: "http"
        host: "api.typesearch.org",
        port: 443,
        protocol: "https"
      }
    ]
  },
  // The following parameters are directly passed to Typesense's search API endpoint.
  //  So you can pass any parameters supported by the search endpoint below.
  //  query_by is required
  additionalSearchParameters: {
    query_by: "domain,font,vendor_url,manufacturer",
//	      facet_by: "vendor_url",
    sort_by: "scanned_at:desc",
    search_cutoff_ms: 500,
  }
});
const searchClient = typesenseInstantsearchAdapter.searchClient;

const search = instantsearch({
  indexName: 'latest_fonts',
  searchClient
});

/*
const searchClient = algoliasearch(
  'latency',
  '6be0576ff61c053d5f9a3225e2a90f76'
);

const search = instantsearch({
  indexName: 'font_purchases',
  searchClient,
  future: { preserveSharedStateOnUnmount: true },
});
*/

const refinements = 
  instantsearch.widgets.refinementList({
    container: '#refinement-list',
    attribute: 'vendor_url',
    showMore: true,
    showMoreLimit: 25,
  });

const configure = 
  instantsearch.widgets.configure({
    length: 1000,
    additionalSearchParameters: {
      query_by: "domain,font,vendor_url,manufacturer"
    }
  });

const renderSearchBox = (renderOptions, isFirstRender) => {
  const { query, refine, isSearchStalled } = renderOptions;
  console.log('log');
  if (!query) {
    if (isFirstRender) {
      console.log('removing search');
      search.removeWidget(refinements);
      search.addWidget(configure);
    }
  } else {
    if (!search.renderState['latest_fonts'].refinementList) {
      console.log('adding search');
      search.removeWidget(configure);
      search.addWidget(refinements);
    }
  }
}

const virtualSearchBox = instantsearch.connectors.connectSearchBox(renderSearchBox);

search.addWidgets([
  virtualSearchBox({}),
  instantsearch.widgets.stats({
    container: '#stats'
  }),
/*
  instantsearch.widgets.refinementList({
    container: '#refinement-list',
    attribute: 'font',
    showMore: true,
    showMoreLimit: 50,
  }),
*/
  instantsearch.widgets.hits({
    container: '#hits',
    templates: {
      item(hit, {html, components}) {
      const scanned_at = new Date(hit.scanned_at * 1000)
      return html`
        <div>
          <img src="" align="left" alt="" />
          <div class="hit-name">
            <a href="http://${hit.domain}">${components.Highlight({ hit, "attribute": "domain" })}</a>
          </div>
          <div class="hit-description">
            Font : ${components.Highlight({ hit, "attribute": "font" })}
          </div>
          <div class="hit-description">
            Vendor URL : ${components.Highlight({ hit, "attribute": "vendor_url" })}
          </div>
          <div class="hit-description">
            Font URL: ${hit.font_url}
          </div>
          <div class="hit-description">
	    Manufacturer : ${components.Highlight({ hit, "attribute": "manufacturer" })}
          </div>
          <div class="hit-description">
            Scanned at: ${scanned_at.toLocaleString()}
          </div>
          <div class="hit-description">
            scanned font id: ${hit.scanned_font_id}
          </div>
        </div>
      `;
      },},
  }),
  instantsearch.widgets.configure({
    length: 1000,
    hitsPerPage: 16,
  }),
  instantsearch.widgets.pagination({
    container: '#pagination',
  }),
]);

search.start();

const recentSearchesPlugin = createLocalStorageRecentSearchesPlugin({
  key: 'instantsearch',
  limit: 3,
  transformSource({ source }) {
    return {
      ...source,
      onSelect({ setIsOpen, setQuery, item, event }) {
        onSelect({ setQuery, setIsOpen, event, query: item.label });
      },
    };
  },
});

const querySuggestionsPlugin = createQuerySuggestionsPlugin({
  searchClient,
  indexName: 'latest_fonts',
  getSearchParams() {
    return recentSearchesPlugin.data.getAlgoliaSearchParams({ hitsPerPage: 6 });
  },
  transformSource({ source }) {
    return {
      ...source,
      sourceId: 'querySuggestionsPlugin',
      onSelect({ setIsOpen, setQuery, event, item }) {
        onSelect({ setQuery, setIsOpen, event, query: item.query });
      },
      getItems(params) {
        if (!params.state.query) {
          return [];
        }

        return source.getItems(params);
      },
    };
  },
});

autocomplete({
  container: '#searchbox',
  openOnFocus: true,
  detachedMediaQuery: 'none',
  onSubmit({ state }) {
    setInstantSearchUiState({ query: state.query });
  },
  plugins: [recentSearchesPlugin, querySuggestionsPlugin],
});

function setInstantSearchUiState(indexUiState) {
  search.mainIndex.setIndexUiState({ page: 1, ...indexUiState });
}

function onSelect({ setIsOpen, setQuery, event, query }) {
  if (isModifierEvent(event)) {
    return;
  }

  setQuery(query);
  setIsOpen(false);
  setInstantSearchUiState({ query });
}

function isModifierEvent(event) {
  const isMiddleClick = event.button === 1;

  return (
    isMiddleClick ||
    event.altKey ||
    event.ctrlKey ||
    event.metaKey ||
    event.shiftKey
  );
}
